/**
 * @flow
 * @relayHash e8e9f9edd339beafa0cd4a61fc7954c5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateClearstreamCashTransferPreAdviseFileMutationVariables = {|
  forDate?: ?any,
  pendingTransactionIds?: ?$ReadOnlyArray<?string>,
  settledTransactionIds?: ?$ReadOnlyArray<?string>,
|};
export type CreateClearstreamCashTransferPreAdviseFileMutationResponse = {|
  +createClearstreamCashTransferPreAdviseFile: ?{|
    +preAdviseFile: ?{|
      +id: string,
      +createdAt: any,
      +csvUrl: ?string,
      +csv: ?string,
    |}
  |}
|};
export type CreateClearstreamCashTransferPreAdviseFileMutation = {|
  variables: CreateClearstreamCashTransferPreAdviseFileMutationVariables,
  response: CreateClearstreamCashTransferPreAdviseFileMutationResponse,
|};
*/


/*
mutation CreateClearstreamCashTransferPreAdviseFileMutation(
  $forDate: Date
  $pendingTransactionIds: [ID]
  $settledTransactionIds: [ID]
) {
  createClearstreamCashTransferPreAdviseFile(forDate: $forDate, pendingTransactionIds: $pendingTransactionIds, settledTransactionIds: $settledTransactionIds) {
    preAdviseFile {
      id
      createdAt
      csvUrl
      csv
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "forDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "pendingTransactionIds",
    "type": "[ID]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "settledTransactionIds",
    "type": "[ID]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createClearstreamCashTransferPreAdviseFile",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "forDate",
        "variableName": "forDate"
      },
      {
        "kind": "Variable",
        "name": "pendingTransactionIds",
        "variableName": "pendingTransactionIds"
      },
      {
        "kind": "Variable",
        "name": "settledTransactionIds",
        "variableName": "settledTransactionIds"
      }
    ],
    "concreteType": "CreateClearstreamCashTransferPreAdviseFile",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "preAdviseFile",
        "storageKey": null,
        "args": null,
        "concreteType": "CSCashTransferPreAdviseFileNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "csvUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "csv",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateClearstreamCashTransferPreAdviseFileMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateClearstreamCashTransferPreAdviseFileMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateClearstreamCashTransferPreAdviseFileMutation",
    "id": null,
    "text": "mutation CreateClearstreamCashTransferPreAdviseFileMutation(\n  $forDate: Date\n  $pendingTransactionIds: [ID]\n  $settledTransactionIds: [ID]\n) {\n  createClearstreamCashTransferPreAdviseFile(forDate: $forDate, pendingTransactionIds: $pendingTransactionIds, settledTransactionIds: $settledTransactionIds) {\n    preAdviseFile {\n      id\n      createdAt\n      csvUrl\n      csv\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ac691648d15a1973669432587bc1bbf4';
module.exports = node;
